import * as React from 'react';
import {Card, Grid} from '@mui/material';
import CardContent from '@mui/material/CardContent';
import Typography from '@mui/material/Typography';
import {BarChart} from '@mui/x-charts';
import {Unstable_RadarChart as RadarChart} from '@mui/x-charts/RadarChart';
import {XYVO} from "@/service/analyze";
import {transformMoney} from "@/helper/method";

export interface PaymentMethodDistProps {
    areaPaybacks?: XYVO[]
    receiveMethods?: XYVO[]
    loading: boolean
}

export default function PaymentMethodDist({areaPaybacks, receiveMethods, loading}: PaymentMethodDistProps) {
    return (
        <Card variant="outlined" sx={{width: '100%'}}>
            <CardContent>
                <Grid container justifyContent={'space-between'} spacing={3}>
                    <Grid size={12}>
                        <Typography component="h2" variant="subtitle2" gutterBottom>
                            区域回款排行
                        </Typography>
                        <BarChart
                            // width={200}
                            loading={loading}
                            localeText={{loading: "加载中"}}
                            height={180}
                            margin={{left: 0, right: 0, top: 10, bottom: 0}}
                            hideLegend={true}
                            series={[
                                {data: areaPaybacks?.map(item => item.y), valueFormatter: value => transformMoney(value), label: '金额', id: 'area', color: '#FFDDAB'}
                            ]}
                            xAxis={[{
                                categoryGapRatio: 0.6, disableTicks: true,
                                data: areaPaybacks?.map(item => item.x),
                            }]}
                            yAxis={[{width: 34, valueFormatter: (value: number) => transformMoney(value), disableLine: true, disableTicks: true}]}
                        />
                    </Grid>
                    {/*<Grid size={5}>*/}
                    {/*    <Typography component="h2" variant="subtitle2" gutterBottom>*/}
                    {/*        到账方式分布*/}
                    {/*    </Typography>*/}
                    {/*    <RadarChart*/}
                    {/*        height={180}*/}
                    {/*        loading={loading}*/}
                    {/*        localeText={{loading: "加载中"}}*/}
                    {/*        margin={{top: 10, bottom: 10}}*/}
                    {/*        highlight={'none'}*/}
                    {/*        hideLegend={true}*/}
                    {/*        series={[{label: '金额', valueFormatter: (value: number) => `${value / 10000}`, data: receiveMethods?.map(item => item.y1) || [],}, {*/}
                    {/*            label: '次数',*/}
                    {/*            data: receiveMethods?.map(item => item.y2) || []*/}
                    {/*        }]}*/}
                    {/*        radar={{*/}
                    {/*            max: 120,*/}
                    {/*            metrics: receiveMethods?.map(item => item.x) || [],*/}
                    {/*        }}*/}
                    {/*    />*/}
                    {/*</Grid>*/}
                </Grid>
            </CardContent>
        </Card>
    );
}
